//Global
import React, { useState } from 'react';

import { useSitecoreContext, Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';

//helper
import LinkWrapper from 'helpers/LinkWrapper/LinkWrapper';
import SVG from 'helpers/SVG/SVG';
import ModalWrapper from 'helpers/ModalWrapper/ModalWrapper';

export type ArticleTitles = {
  SectionTitle: string;
};

export type Fields = {
  ArticleTitles: ArticleTitles[];
};

export type TableOfContentProps = {
  fields: Fields;
};

export type TableOfContentPageProps = {
  Headline: Field<string>;
};

const TableOfContent = (props: TableOfContentProps) => {
  const { sitecoreContext } = useSitecoreContext();
  const { Headline } = sitecoreContext?.route?.fields as TableOfContentPageProps;

  const [activeIndex, setActiveIndex] = useState<number>(-1);

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const createSlug = (str: string) => {
    return str && str.replaceAll(' ', '')?.toLocaleLowerCase();
  };

  const getNavItems = () => {
    return (
      <nav>
        <ul role="list">
          <li>
            <Text field={Headline} tag="span" className="p2-medium block p-4" />
            <hr className="my-0" />
          </li>
          {props?.fields?.ArticleTitles.map((item, index) => (
            <>
              <li
                key={index}
                onClick={() => {
                  setActiveIndex(index);
                  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                  isModalOpen && setIsModalOpen(!isModalOpen);
                }}
              >
                <LinkWrapper
                  field={{
                    value: {
                      text: item.SectionTitle,
                      href: `#${createSlug(item?.SectionTitle)}`,
                      // Add these properties to ensure it's treated as an anchor link
                      linktype: 'anchor',
                      anchor: createSlug(item?.SectionTitle),
                      url: '', // Clear the URL to prevent full path generation
                    },
                  }}
                  className={`block p-4 hover:bg-light-background-neutral-high focus:bg-light-background-neutral-high  hover:no-underline focus:rounded-sm focus:outline-2 focus:outline-light-stroke-primary-variant focus:no-underline  ${
                    activeIndex == index
                      ? 'hover:text-light-fill-primary p3'
                      : 'p3-medium text-light-fill-secondary hover:text-light-fill-secondary'
                  }`}
                ></LinkWrapper>
                <hr className="my-0" />
              </li>
            </>
          ))}
        </ul>
      </nav>
    );
  };

  return (
    <>
      <div
        className={`fixed bottom-12 right-8 block lg:hidden z-[9999] ${
          !isModalOpen ? 'block' : 'hidden'
        }`}
      >
        <button
          onClick={() => {
            setIsModalOpen(true);
          }}
          className="flex h-12 w-12 px-4 py-2 items-center justify-center rounded-3xl border bg-light-background-neutral-variant shadow-small outline-none"
        >
          <SVG
            className="[&_svg]:h-6 [&_svg]:w-6 text-light-fill-secondary"
            svg={'icon-ascending'}
          />
        </button>
      </div>

      <aside className="hidden lg:block max-w-[353px] w-[353px] shadow-small bg-light-background-neutral sticky top-20">
        {getNavItems()}
      </aside>

      {isModalOpen && (
        <ModalWrapper
          position="center"
          modalWidth="w-full"
          //onClose={() => {}}
          isCloseBtnShown={false}
          isMarginAvailable={false}
        >
          <div className={`absolute -bottom-16 md:-bottom-24 right-0 block lg:hidden z-[9999]`}>
            <button
              onClick={() => {
                setIsModalOpen(false);
              }}
              className="flex h-12 w-12 px-4 py-2 items-center justify-center rounded-3xl border bg-light-background-neutral-variant shadow-small outline-none"
            >
              <SVG
                className="[&_svg]:h-6 [&_svg]:w-6 text-light-fill-secondary"
                svg={'icon-close'}
              />
            </button>
          </div>
          {getNavItems()}
        </ModalWrapper>
      )}
    </>
  );
};

export default TableOfContent;
